import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["width", "height", "fill"];
import React from 'react';

var OneManDeliveryIcon = function OneManDeliveryIcon(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? '1em' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '1em' : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#333' : _ref$fill,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: fill,
    width: width,
    height: height
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M18.813 17.25H21v-4.5h-3a.75.75 0 0 1-.712-.513L15.21 6H2.998l-.031 11.25h.97a2.751 2.751 0 0 1 5.126 0h4.624a2.751 2.751 0 0 1 5.126 0zm.142 1.5a2.75 2.75 0 0 1-5.41 0h-4.34a2.75 2.75 0 0 1-5.41 0h-1.58a.75.75 0 0 1-.75-.752L1.5 5.248a.75.75 0 0 1 .75-.748h13.5a.75.75 0 0 1 .712.513l2.079 6.237h3.209a.75.75 0 0 1 .75.75v6a.75.75 0 0 1-.75.75h-2.795zM6.5 19.5a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5zm9.75 0a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5z"
  }));
};

OneManDeliveryIcon.displayName = 'OneManDeliveryIcon';
export default OneManDeliveryIcon;